"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onInitialClientRender = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var onInitialClientRender =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(_) {
    var pluginOptions,
        _showInProduction$axe,
        showInProduction,
        axeOptions,
        _ref2,
        axe,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pluginOptions = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _showInProduction$axe = (0, _objectSpread2.default)({
              showInProduction: false,
              axeOptions: {}
            }, pluginOptions), showInProduction = _showInProduction$axe.showInProduction, axeOptions = _showInProduction$axe.axeOptions;

            if (!(process.env.NODE_ENV === 'development' || showInProduction)) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return import('react-axe');

          case 5:
            _ref2 = _context.sent;
            axe = _ref2.default;
            axe(_react.default, _reactDom.default, 1000, axeOptions);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function onInitialClientRender(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.onInitialClientRender = onInitialClientRender;